<div class="admin-container">
  <div class="admin-header">
      <div class="header-content">
        <h1><i class="icon-settings"></i> Admin Panel</h1>
      </div>
  </div>
  <admin-nav-tabs [activeTab]="activeTab" (tabChange)="setActiveTab($event)"></admin-nav-tabs>

  <!-- Content Area -->
  <div class="admin-content">

    <!-- Colleagues Tab -->
    @if (activeTab === 'colleagues') {
      <div class="tab-content">
        <div class="content-header">
          <h2>Kollégák Kezelése</h2>
          <app-add-new-button 
            text="Új kolléga" 
            (clicked)="openColleagueForm()">
          </app-add-new-button>
        </div>

        <!-- Colleagues Table -->
        <div class="card">
          <colleague-table 
            [colleagues]="colleagues"
            (edit)="editColleague($event)"
            (delete)="deleteColleague($event)">
          </colleague-table>
        </div>
      </div>
    }

    <!-- Logs Tab -->
    @if (activeTab === 'logs') {
      <div class="tab-content">
        <!-- Új extended logs wrapper komponens -->
        <app-extended-logs-wrapper></app-extended-logs-wrapper>
      </div>
    }

    <!-- Products Tab -->
    @if (activeTab === 'products') {
      <app-admin-products></app-admin-products>
    }

    <!-- Settings Tab -->
    @if (activeTab === 'settings') {
      <div>
        <admin-settings 
          [jobTitles]="jobTitles"
          [insuranceCompanies]="insuranceCompanies"
          [lastManualBackupTime]="lastManualBackupTime"
          (openJobTitleForm)="openJobTitleForm()"
          (editJobTitle)="editJobTitle($event)"
          (openInsuranceCompanyForm)="openInsuranceCompanyForm()"
          (editInsuranceCompany)="editInsuranceCompany($event)"
          (createBackup)="onCreateBackup()"
          (restoreBackup)="onRestoreBackup()">
        </admin-settings>
      </div>
    }

    <!-- Monitoring Tab -->
    @if (activeTab === 'monitoring') {
      <admin-monitoring></admin-monitoring>
    }
  </div>
</div>


